<template>
  <codemirror 
    :value="tmpValue" 
    @input="updateValue"
    :options="cmOptions" v-bind:style= "[readOnly ? { backgroundColor: '#eee' } : { backgroundColor: '#fff' }]"
  />
</template>

<script>
import { codemirror } from 'vue-codemirror'
import 'codemirror/mode/xml/xml.js'
import 'codemirror/mode/htmlmixed/htmlmixed.js'
import 'codemirror/mode/javascript/javascript.js'
import 'codemirror/addon/display/autorefresh.js'
import 'codemirror/mode/css/css.js'
import 'codemirror/mode/yaml/yaml.js'
import 'codemirror/lib/codemirror.css'

const LanguageMode = {
  html: 'text/html',
  css: 'text/x-scss',
  json: 'application/json',
  js: 'text/javascript',
  yaml: 'text/x-yaml',
}

export default {
  name: 'CodeEditor',
  components: {
    codemirror
  },
  props: {
    value: {
      type: String,
      default() { return '' },
    },
    language: {
      type: String,
    },
    readOnly: {
      type: Boolean,
    }
  },
  data () {
    return {}
  },
  computed: {
    tmpValue () {
      return this.value || ''
    },
    cmOptions () {
      return {
        autoRefresh:true,
        indentUnit: 4,
        tabSize: 4,
        styleActiveLine: true,
        mode: LanguageMode[this.language],
        lineNumbers: true,
        lineWrapping: true,
        matchBrackets: true,
        showCursorWhenSelecting: true,
        readOnly: this.readOnly,
        extraKeys: {
          'Tab': cm => {
            if (cm.somethingSelected()) {
              cm.indentSelection('add')
            } else {
              cm.replaceSelection(cm.getOption('indentWithTabs') ? '\t' : Array(
                cm.getOption('indentUnit') + 1).join(' '), 'end', '+input')
            }
          }
        }
      }
    }
  },
  methods: {
    updateValue(newValue) {
      if (newValue != this.tmpValue) {
        this.$emit('input', newValue)
      }
    },
  },
  watch: {
    language (newValue) {
      if (newValue && newValue !== this.mode) {
        this.cmOptions.mode = LanguageMode[newValue]
      }
    },
  }
}
</script>

<style lang="scss">
.CodeMirror {
    /* Bootstrap Settings */
    box-sizing: border-box;
    margin: 0;
    font: inherit;
    overflow: auto;
    font-family: inherit;
    display: block;
    width: 100%;
    font-size: 14px;
    line-height: 1.42857143;
    color: #555;
    background-color: transparent;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);
    transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
    /* Code Mirror Settings */
    font-family: monospace;
    position: relative;
    overflow: hidden;
    min-height: 50px;
    height: auto !important;
}
</style>
